'use client'

import { ComponentProps } from 'react'
import { IMAGE_PATH } from '../../config/constants'
import SectionTitle from '@/app/(site)/(static)/about/components/section-title'
import { cn } from '@/util/cn'
import VALUES from './values'
import Typography from '@/app/components/typography'

const GRADIENTS = [
    'bg-[linear-gradient(-135deg,_rgb(255,_102,_102)_0%,_rgb(230,_70,_182)_100%)]',
    'bg-[linear-gradient(-135deg,_rgb(153,_51,_255)_0%,_rgb(97,_87,_255)_100%)]',
    'bg-[linear-gradient(45deg,_rgb(255,_102,_102)_0%,_rgb(255,_243,_92)_100%)]',
    'bg-[linear-gradient(-135deg,_rgb(0,_255,_153)_0%,_rgb(0,_204,_255)_100%)]',
] as const

type Props = {
    sectionTitleProps?: Partial<ComponentProps<typeof SectionTitle>>
    className?: string
}

const PhilosophiesAndValuesSection = ({ sectionTitleProps, className }: Props) => (
    <section id="philosophies-and-values" className={className}>
        <div className="relative">
            <SectionTitle
                title="Our Philosophies"
                description="This is what we believe. These philosophies guide our approach to GIPHY's community, culture, and products."
                src={`${IMAGE_PATH}/stickers/third-eye.gif`}
                {...sectionTitleProps}
                classNames={{
                    ...sectionTitleProps?.classNames,
                    base: cn('mb-[1.125rem] [--img-dimension:7.8rem]', sectionTitleProps?.classNames?.base),
                }}
            />

            <div className="mx-auto mt-12 flex w-full max-w-[1224px] flex-col md:mt-[92px]">
                {VALUES.map(({ title, description, src }, index) => {
                    const reverseOnDesktop = index % 2 !== 0
                    const gradientClass = GRADIENTS[index % GRADIENTS.length]

                    return (
                        <div
                            key={index}
                            className="my-2.5 grid place-items-center gap-4 md:my-5 md:min-h-[19.5rem] md:grid-cols-2"
                        >
                            <img
                                src={src}
                                alt=""
                                className={cn(
                                    'h-40 w-full rounded-lg object-cover md:order-1 md:h-[312px]',
                                    reverseOnDesktop && 'md:order-2'
                                )}
                            />

                            <div
                                className={cn(
                                    'flex w-full flex-col justify-center py-4 md:order-2 md:px-8 lg:px-0',
                                    reverseOnDesktop && 'md:order-1'
                                )}
                            >
                                <div className="mx-auto w-full text-left md:max-w-[28.125rem]">
                                    <Typography
                                        variant="h2"
                                        fontFamily="nexaBlack"
                                        className={cn(`mb-5 bg-clip-text font-black text-transparent`, gradientClass)}
                                    >
                                        {title}
                                    </Typography>

                                    <Typography variant="text-lg">{description}</Typography>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    </section>
)

export default PhilosophiesAndValuesSection
